import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Calendar } from "lucide-react";
import { blogPosts } from "@/data/blog";

const BlogTeaserSection: React.FC = () => {
  // Take the newest 3 posts (array is already ordered newest-first)
  const latestPosts = blogPosts.filter(p => !p.comingSoon).slice(0, 3);

  return (
    <section className="section-spacing bg-warm-white">
      <div className="container">
        {/* Header */}
        <div className="max-w-2xl mx-auto text-center mb-10">
          <span className="text-sm font-medium text-sage-500 tracking-wide uppercase mb-2 block">
            Reflexionen & Impulse
          </span>
          <h2 className="font-heading text-3xl md:text-4xl text-deep-sage mb-4">
            Aktuelle Beiträge
          </h2>
          <p className="text-soft-charcoal text-lg leading-relaxed">
            Gedanken zu Coaching, Finanzen und persönlicher Entwicklung.<br />
            Wissenschaftlich fundiert und praxisnah.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 mb-10">
          {latestPosts.map((post) => (
            <Link
              key={post.slug}
              to={`/blog/${post.slug}`}
              className="group bg-white rounded-xl overflow-hidden shadow-soft hover:shadow-elevation transition-all duration-300 flex flex-col"
            >
              {/* Image */}
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={post.imageUrl}
                  alt={post.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>

              {/* Content */}
              <div className="p-5 flex flex-col flex-1">
                <span className="text-xs font-medium text-sage-500 uppercase tracking-wide mb-2">
                  {post.category}
                </span>
                <h3 className="font-heading text-lg text-deep-sage mb-2 group-hover:text-primary transition-colors line-clamp-2">
                  {post.title}
                </h3>
                <p className="text-soft-charcoal text-sm leading-relaxed line-clamp-3 flex-1">
                  {post.excerpt}
                </p>
                <div className="flex items-center gap-2 mt-4 text-xs text-sage-400">
                  <Calendar className="h-3.5 w-3.5" />
                  <time>{post.date}</time>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <Link
            to="/blog"
            className="inline-flex items-center gap-2 text-primary font-medium hover:gap-3 transition-all duration-300"
          >
            Alle Beiträge entdecken
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default BlogTeaserSection;
